const products = {
    car: 'car',
    modified: 'modified',
    courier: 'courier',
    fleet: 'fleet',
    generic: 'generic',
    goods_in_transit: 'goods_in_transit',
    hgv: 'hgv',
    home: 'home',
    landlord: 'landlord',
    mini_bus: 'mini_bus',
    motor_bike: 'motor_bike',
    motor_home: 'motor_home',
    motor_trade: 'motor_trade',
    public_liability: 'public_liability',
    school: 'school',
    taxi: 'taxi',
    travel: 'travel',
    van: 'van',
    special: 'special',
    quad: 'quad',
    sme: 'sme',
    boat: 'boat',
    energy: 'energy',
    caravan: 'caravan',
    gap: 'gap',

    fresh_web_car: 'fresh_web_car',
    fresh_web_modified: 'fresh_web_modified',
    fresh_web_courier: 'fresh_web_courier',
    fresh_web_fast_food: 'fresh_web_fast_food',
    fresh_web_fleet: 'fresh_web_fleet',
    fresh_web_generic: 'fresh_web_generic',
    fresh_web_goods_in_transit: 'fresh_web_goods_in_transit',
    fresh_web_hgv: 'fresh_web_hgv',
    fresh_web_home: 'fresh_web_home',
    fresh_web_landlord: 'fresh_web_landlord',
    fresh_web_mini_bus: 'fresh_web_mini_bus',
    fresh_web_motor_bike: 'fresh_web_motor_bike',
    fresh_web_motor_home: 'fresh_web_motor_home',
    fresh_web_motor_trade: 'fresh_web_motor_trade',
    fresh_web_public_liability: 'fresh_web_public_liability',
    fresh_web_school: 'fresh_web_school',
    fresh_web_taxi: 'fresh_web_taxi',
    fresh_web_travel: 'fresh_web_travel',
    fresh_web_van: 'fresh_web_van',
    fresh_web_special: 'fresh_web_special',
    fresh_web_quad: 'fresh_web_quad',
    fresh_web_sme: 'fresh_web_sme',
    fresh_web_boat: 'fresh_web_boat',
    fresh_web_energy: 'fresh_web_energy',
    fresh_web_caravan: 'fresh_web_caravan',
    fresh_web_gap: 'fresh_web_gap',

    unsubscribe: 'unsubscribe',
    resubmit: 'resubmit',
    schedule: 'schedule'
};
export default products;
